
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoBankDialog extends Serenity.EntityDialog<PoBankRow, any> {
        protected getFormKey() { return PoBankForm.formKey; }
        protected getIdProperty() { return PoBankRow.idProperty; }
        protected getLocalTextPrefix() { return PoBankRow.localTextPrefix; }
        protected getNameProperty() { return PoBankRow.nameProperty; }
        protected getService() { return PoBankService.baseUrl; }
        protected getDeletePermission() { return PoBankRow.deletePermission; }
        protected getInsertPermission() { return PoBankRow.insertPermission; }
        protected getUpdatePermission() { return PoBankRow.updatePermission; }

        protected form = new PoBankForm(this.idPrefix);

    }
}